<template>
  <main>
    <SelectLocale />
    <div
      :class="{ fullscreen: fullscreen }"
      ref="wrapper"
      @fullscreenchange="onFullscreenChange"
    >
      <qr-stream @decode="onDecode" @init="onInit">
        <div class="frame">
          <img src="@/assets/images/marker_line.png" alt="marker" />
        </div>
      </qr-stream>
    </div>
  </main>
</template>
<script>
import { QrStream } from "vue3-qr-reader";
import SelectLocale from "../../components/SelectLocale.vue";
export default {
  components: {
    QrStream,
    SelectLocale,
  },
  data() {
    return {
      fullscreen: true,
    };
  },
  methods: {
    onDecode(url) {
      var params = url.split("antiquity/");
      this.$router.push({ name: "AntiquityId", params: { id: params[1] } });
    },
    onFullscreenChange(event) {
      console.log(event);
      // This becomes important when the user doesn't use the button to exit
      // fullscreen but hits ESC on desktop, pushes a physical back button on
      // mobile etc.

      this.fullscreen = document.fullscreenElement !== null;
    },

    requestFullscreen() {
      const elem = this.$refs.wrapper;

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },

    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        let message = "";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "User denied the request for Camera.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Camera information is unavailable.";
            break;
          case error.TIMEOUT:
            message = "The request to get user Camera timed out.";
            break;
          case error.UNKNOWN_ERROR:
            message = "An unknown error occurred.";
            break;
        }
        alert(message);
      } finally {
        console.log("a");
      }
    },
    clickEvent() {
      console.log(this.$refs.scene.contentWindow);
      this.$refs.scene.contentWindow.postMessage(
        {
          type: "type",
          data: {
            model: this.model,
          },
        },
        "*"
      );
    },
  },
};
</script>

<style scoped>
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.frame {
  width: 80%;
  max-width: 50%;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);
}
.frame img {
  width: 100%;
}
</style>